import AdminPayrollAndBenefitsPage from "./AdminPayrollAndBenefitsPage";

export default AdminPayrollAndBenefitsPage;
